import React, {Component} from 'react';
import Header from '../Componentes/header'
import Footer from '../Componentes/footer'
import { Row, Col } from 'reactstrap'

export default class NoAutorizado extends Component {

    render() {
        return (
            <html>
                <Header />
                <div className="container">
                    <div className="login-page">
                        <div className="form">
                                <div className="container ">
                                    <Row>
                                        <Col className="align-self-center">
                                            <h3>Cuenta sin activar</h3>
                                        </Col>
                                        <div className="p-3">
                                            <p className="text-justify" >Contacta a tu administrador para solicitar mas información</p>
                                        </div>
                                    </Row>
                                </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </html>
        )
    }
}